define('QuickAddOnPDP.View', [
    'Backbone',
    'Cart.Confirmation.View',
    'quick_add_on_pdp.tpl',
    'SC.Configuration',
    'LiveOrder.Line.Model',
    'Cart.Confirmation.Helpers',
    'Item.Model',
    'LiveOrder.Model',
    'jQuery'
], function QuickAddOnPDPView(
    Backbone,
    CartConfirmationView,
    quickAddOnPdp,
    Configuration,
    LiveOrderLineModel,
    CartConfirmationHelpers,
    ItemModel,
    LiveOrderModel,
    jQuery
) {
    'use strict';

    return Backbone.View.extend({
        events: {
            'click [data-action="add-a-case-to-cart"]': 'addCaseToCart'
        },
        template: quickAddOnPdp,
        initialize: function initialize(options) {
            this.application = options.application;
            this.pdp = this.application && this.application.getComponent('PDP');
            this.cart = this.application && this.application.getComponent('Cart');
            this.item = this.pdp && this.pdp.getItemInfo();
            this.stockInfo = this.pdp && this.pdp.getStockInfo();
            this.internalId = this.item.item && this.item.item.internalid;
            this.saleUnit = this.item.item && this.item.item.saleunit;
            this.caseSize = this.item.item && this.item.item.custitem_nspos_casesize;
            this.addACase = null;
            if (!((this.stockInfo && this.stockInfo.showOutOfStockMessage) || (this.stockInfo && this.stockInfo.isNotAvailableInStore))) {
                if (this.internalId && this.saleUnit && this.caseSize) {
                    if (this.saleUnit === 'Unit') {
                        if (this.caseSize !== 1) {
                            this.addACase = this.caseSize;
                        }
                    } else {
                        this.saleUnit = this.saleUnit.substr(0, this.saleUnit.indexOf(' '));
                        this.saleUnit = Number(this.saleUnit);
                        if (this.caseSize !== this.saleUnit) {
                            this.addACase = this.caseSize / this.saleUnit;
                        }
                    }
                }
            }
        },
        addCaseToCart: function addCaseToCart(e) {
            var self;
            var liveOrder;
            var line;
            e.preventDefault();
            e.stopPropagation();
            self = this;
            liveOrder = LiveOrderModel.getInstance();
            line = {
                quantity: self.addACase,
                item: {
                    internalid: self.internalId
                }
            };
            if (e.originalEvent) {
                self.cart.addLine({
                    line: line
                }).then(function fnThen() {
                    line = liveOrder.getLatestAddition();
                    CartConfirmationHelpers.showCartConfirmation(jQuery.Deferred().resolve(), line, self.application);
                });
            }
        },
        getContext: function getContext() {
            return {
                addACaseActive: !!(this.addACase),
                addACase: this.addACase
            };
        }
    });
});
